import { render, staticRenderFns } from "./season-start.vue?vue&type=template&id=483152ee"
import script from "./season-start.vue?vue&type=script&lang=js"
export * from "./season-start.vue?vue&type=script&lang=js"
import style0 from "./season-start.vue?vue&type=style&index=0&id=483152ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports